import React from 'react';
import { Link } from 'react-router-dom';

import backgroundImage from '../../assets/landing.jpg';
import { Button } from '../components';
import { AfterLife } from '../components/logo';
import LandingPageSections from '../components/pseudo-landing-page';

export function LandingPage() {
  return (
    <div className="landing-page">
      <LandingHeader />
      <LandingIntro />
      {/* <TrustedPartners /> */}
      <LandingPageSections />
    </div>
  );
}

function LandingHeader() {
  return (
    <div className="landing-header">
      {/* <div className="veil" /> */}
      <AfterLife />
      <Link to="/login" style={{ color: 'white', zIndex: 1 }}>
        Log In
      </Link>
    </div>
  );
}

function LandingIntro() {
  return (
    <div>
      <div className="title-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
        <h1 style={{ marginBottom: '32px' }}>Discover the beyond</h1>
        <Link to="/signup">
          <Button>Sign Up Now!</Button>
        </Link>
        <br />
        {/* TODO: add the or, "or log in" */}
      </div>
      <div className="description">
        <p>
          Embark on a journey to explore the mysteries of the afterlife with the AfterLife App.
          Unveil secrets, connect with lost loved ones, and find solace in the unknown.
        </p>
      </div>
    </div>
  );
}

function TrustedPartners() {
  return (
    <div>
      <h1>Trusted Partners</h1>
    </div>
  );
}

function CustomerReviews() {
  return (
    <div>
      <h2>Customer Reviews</h2>
    </div>
  );
}

function PricingPlans() {
  return (
    <div>
      <h2>Pricing Plans</h2>
    </div>
  );
}

function Faqs() {
  return (
    <div>
      <h2>FAQs</h2>
    </div>
  );
}
